import styled from "styled-components/macro";
import CustomRangeSelector from "../../CustomRangeSelector";

export function DateRangePickerMode({
  autoSubmit,
  onSubmit,
}: {
  /** whenever user changes the date range using this picker, they normally have to click submit button, this prevents spamming server with unnecessary requests; use `autoSubmit` if the picker is on a page which doesn't fetch data to simplify the picking process (removes submit/clear buttons) */
  autoSubmit?: boolean;
  onSubmit?: () => void;
}) {
  return (
    <DateRangePickerModeStyles>
      <CustomRangeSelector autoSubmit={autoSubmit} onSubmit={onSubmit} />
    </DateRangePickerModeStyles>
  );
}
const DateRangePickerModeStyles = styled.div`
  margin-top: -16px;
`;
